import authInstance from "../Interceptor";

export const BarDayReportEffect = (pageNo) => {
  return authInstance.get(
    `/reports/reportShotsDayWise?pageNo=${pageNo}&pagesize =10&pagination_required=true`
  );
};

export const BarWeekReportEffect = (pageNo) => {
  return authInstance.get(
    `/reports/reportShotsWeekWise?pageNo=${pageNo}&pagesize =10&pagination_required=true`
  );
};

export const BarMonthReportEffect = (pageNo) => {
  return authInstance.get(
    `/reports/reportShotsMonthWise?pageNo=${pageNo}&pagesize =10&pagination_required=true`
  );
};

export const BarDayDateSearchReportEffect = ({
  pageNo,
  start_date,
  end_date,
}) => {
  return authInstance.get(
    `/reports/reportShotsDayWise?pageNo=${pageNo}&pagesize=10&pagination_required=true&start_date=${start_date}&end_date=${end_date}`
  );
};

export const BarWeekDateSearchReportEffect = ({
  pageNo,
  start_date,
  end_date,
}) => {
  return authInstance.get(
    `/reports/reportShotsWeekWise?pageNo=${pageNo}&pagesize=10&pagination_required=true&start_date=${start_date}&end_date=${end_date}`
  );
};

export const BarMonthDateSearchReportEffect = ({
  pageNo,
  start_date,
  end_date,
}) => {
  return authInstance.get(
    `/reports/reportShotsMonthWise?pageNo=${pageNo}&pagesize=10&pagination_required=true&start_date=${start_date}&end_date=${end_date}`
  );
};

export const SearchBarReportEffect = () => {
  return authInstance.get(`/reports/reportShotslist`);
};
